package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/**
 * DSL 内建对象 `time` 暴露的时间工具方法（仅作为类型标记）。
 * 具体方法在 CallDispatcher.invokeTimeApi 中实现。
 */
class TimeApi private constructor() {
    companion object {
        @JvmField val INSTANCE: TimeApi = TimeApi()

        @JvmField val NOOP: TimeApi = INSTANCE
    }
}
